import { render } from "./TopAppDesktop.vue?vue&type=template&id=7a06ac11&scoped=true"
import script from "./TopAppDesktop.vue?vue&type=script&lang=js"
export * from "./TopAppDesktop.vue?vue&type=script&lang=js"

import "./TopAppDesktop.vue?vue&type=style&index=0&id=7a06ac11&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7a06ac11"]])

export default __exports__